


import React, { useState, useEffect } from "react";
import { FormControlLabel, Switch } from "@material-ui/core";

function SwitchCheck({ initialValue, onSwitchChange  }) {
  const [checked, setChecked] = useState(initialValue);

  useEffect(() => {
    setChecked(initialValue);
  }, [initialValue]);

  const handleSwitchChange = () => {
    const newValue = !checked;
    setChecked(newValue);
    onSwitchChange(newValue);
  };

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={handleSwitchChange}
            color="primary"
          />
        }
        label={checked ? "Enable" : "Disable"}
      />
    </div>
  );
}

export default SwitchCheck;
